import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import ROUTES from '../routes';
import api from './../config/axiosInstance';
import { logout } from '../config/authSlice';

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector((state) => state.auth.user);
    const profileImage = user?.img ? process.env.REACT_APP_IMG_URL + user.img : null;

    const handleLogout = async () => {
        try {
            await api.post('auth/logout');
        } catch (err) {
            console.error(err);
        } finally {
            dispatch(logout());
            navigate(ROUTES.LOGIN);
        }
    };

    return (
        <>
            <div className="nav-header bg-info">
                <a href="#/" className="brand-logo">
                    {/* <img className="logo-abbr" src="/assets/logo.svg" alt="" /> */}
                    <img className="logo-compact" src="/assets/logo.png" alt="" />
                    {/* <img className="brand-title" src="/assets/logo.svg" alt="" /> */}
                </a>
                <div className="nav-control">
                    <div className="hamburger">
                        <span className="line"></span><span className="line"></span><span className="line"></span>
                    </div>
                </div>
            </div>
            <div className="header bg-info">
                <div className="header-content">
                    <nav className="navbar navbar-expand">
                        <div className="collapse navbar-collapse justify-content-between">
                            <div className="header-left">
                                <div className="dashboard_bar">
                                    <div className="search_bar dropdown">
                                        <div className="dropdown-menu p-0 m-0">
                                            {/* Search Form */}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <ul className="navbar-nav header-right">
                                <li className="nav-item dropdown header-profile">
                                    <a className="nav-link" href="#/" role="button" data-bs-toggle="dropdown">
                                        <div className="header-info">
                                            <span className="text-black">{user?.name || 'User'}</span>
                                            <p className="fs-12 mb-0">{user?.username || 'Admin'}</p>
                                        </div>
                                        <img src={profileImage} width="20" alt="" />
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end">
                                        <Link
                                            to={ROUTES.PROFILE}
                                            className="dropdown-item ai-icon">
                                            <i className="fa-solid fa-user"></i>
                                            <span className="ms-2">Profile </span>
                                        </Link>
                                        <a
                                            href="#/"
                                            onClick={handleLogout}
                                            className="dropdown-item ai-icon"
                                        >
                                            <i className="fa-solid fa-right-from-bracket"></i>
                                            <span className="ms-2">Logout </span>
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </>
    )
}

export default Header